<script setup lang="ts">
const props = defineProps<{
  variant: number
}>()

const viewBox = computed(() => {
  let viewBox = '0 0 379 644'

  if (props.variant === 2)
    viewBox = '0 0 736 1069'

  return viewBox
})
</script>

<template>
  <svg
    fill="none"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
  >

    <linearGradient
      id="paint0_linear_974_9035"
      gradientUnits="userSpaceOnUse"
      x1="300.438"
      x2="300.438"
      y1="42.7735"
      y2="589.958"
    >
      <stop
        stop-color="#DC7818"
        stop-opacity="0.214803"
      />
      <stop
        offset="1"
        stop-color="#DC7818"
      />
    </linearGradient>

    <path
      v-if="variant === 1 || !variant"
      class="path"
      d="M359.727 0.825111C359.727 0.825111 228.126 304.678 314.366 315.731C381.488 324.333 385.265 238.117 324.533 214.339C307.769 207.775 272.833 199.893 272.833 199.893C272.833 199.893 0.143378 135.707 1.52165 245.67C2.87281 353.512 421.442 629.977 490.644 642.544"
      stroke="url(#paint0_linear_974_9035)"
      stroke-width="2"
    />
    <path
      v-if="variant === 2"
      class="path"
      d="M371.425 0C371.425 0 112.856 375.161 221.425 416.617C305.925 448.882 335.793 332.18 263.969 281.121C244.143 267.026 221.327 262.412 199.127 266.922C152.958 276.301 34.9893 290.217 4.92532 440.957C-24.5597 588.791 119.545 714.024 187.216 759.031C224.229 783.648 267.303 787.535 305.981 768.018C342.383 749.65 374.172 711.788 352.138 633.751C351.645 632.006 351.156 630.258 350.693 628.5C347.229 615.351 325.918 542.815 276.185 538.126C250.668 535.721 226.222 552.019 211.3 579.799C191.005 617.578 136.971 686.958 179.552 799.376C222.134 911.794 274.377 935.179 360.425 973.5C446.474 1011.82 548.425 995.775 551.925 965.208C555.425 934.641 516.298 933.378 517.425 962.378C518.553 991.378 626.149 1042.98 741.425 1067.5"
      stroke="url(#paint0_linear_974_9035)"
      stroke-width="2"
    />
  </svg>
</template>

<style>
.path {
  stroke-dasharray: 5000;
  stroke-dashoffset: 5000;
  animation: dash 5s linear forwards;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
